/* eslint-disable */
import React, { Component } from 'react';
import {Button, Form, Grid, Header, Icon, Label, Menu, Message, Popup, Segment, Tab} from 'semantic-ui-react';
import InspectionHistory from "./inspection_history";
import {getAddressList, mergePropertyWithExistingAddress} from "../../data/user_api";
import {PROPERTY_API_URL} from "../../constants/api_routes";

class ViewPropertyDetails extends Component {

    constructor(props){
        super(props);
        this.state = {
            showMergeOptions: false,
            selectedInspectionsPropertyId: undefined,
            isFetching: true,
            addresses: [],
            selectedMergeAddress:undefined,
            selectedMergeAddressInvalid:false,
            selectedMergeAddressId:undefined,
            openPopup:false
        }
    }

    componentWillMount() {
        if (!this.props.disableMerge) {
        this.getPropertyAddressList().then(() => {
            this.setState({isFetching: false})
        });
    }
    }

    getPropertyAddressList = async () => {
        let addressList = await getAddressList(PROPERTY_API_URL);
        let addressOptions = [];
        for (let i = 0; i < addressList.length; i++) {
            if(this.props.selectedObject[0]['id'] !== addressList[i]['property_id']) {
                let obj = {
                    key: addressList[i].id,
                    text:addressList[i].address,
                    children: <div><span>{addressList[i].address}</span><span className="pull-right inspectionCount"><Label circular color='blue'>
                    {addressList[i]['inspection_count']}
                </Label></span></div>,
                    value: addressList[i].id,
                    address: addressList[i]
                };
                addressOptions.push(obj);
            }
        }
        this.setState({addresses: addressOptions});
    };

    handleMergeAddressSelect = async () => {
        if(this.state.selectedMergeAddressId === undefined){
            this.setState({selectedMergeAddressInvalid:true,selectedMergeAddressId:undefined});
            return;
        }
        this.setState({merging:true});
        const formData = new FormData();
        formData.append("property_id",this.props.selectedObject[0]['id']);
        formData.append("property_address_id",this.state.selectedMergeAddressId);
        const response = await mergePropertyWithExistingAddress(formData);
        this.setState({message:response});
        this.setState({merging:false,openPopup:false});
    };


    render() {
        const property = this.props.selectedObject[0];
        const panes = [
            {
                menuItem: {key: 'propertyDetail', content: 'General Details'},
                render: () => <Tab.Pane>
                    <Grid stackable style={{marginTop: '0.5em'}}>
                        <Grid.Row>
                            <Grid.Column width={14}>
                                <Header textAlign='left'
                                        size='large'>{property['full_address']}</Header>
                            </Grid.Column>
                            { this.props.userRole === 'admin' && !this.props.disableMerge && <Grid.Column width={2}>
                                <Popup
                                    trigger={<div className="pull-right" style={{width:'150px'}}><Button fluid icon negative onClick={() => this.setState({
                                        showMergeOptions: true,
                                        openPopup:true,
                                        selectedInspectionsPropertyId: this.props.selectedObject[0]['id']
                                    })}><Icon size="large" name='linkify' rotated={'clockwise'}/> Merge</Button></div>}
                                    content={<div style={{width: '600px', minHeight: '100px'}}>
                                        <Segment style={{margin:'20px 5px 20px 5px'}}>
                                            <Header content="Merge Property with existing property address"/>
                                            <Form onSubmit={this.handleMergeAddressSelect}>
                                                {!this.state.mergeAddressSelected ?<div> <Form.Dropdown
                                                    options={this.state.addresses}
                                                    search
                                                    selection
                                                    fluid
                                                    deburr
                                                    error={this.state.selectedMergeAddressInvalid}
                                                    placeholder="Select property address to merge with"
                                                    loading={this.state.isFetching}
                                                    onChange={(e,options) => {
                                                        const element = options.options.filter(function(option)
                                                        {
                                                            return (options.value === option.value);
                                                        });
                                                        this.setState({selectedMergeAddressId:options.value,selectedMergeAddress:element[0]})
                                                    }}
                                                /></div>:
                                                    <Segment>
                                                        <div>
                                                            Merging property having Address <span className="format-bold">{property['full_address']}</span> with <Label circular color='blue'> {this.props.selectedObject[0]['inspection_count']}</Label> inspections onto >>>>>> <span className="format-bold">{this.state.selectedMergeAddress['children']}</span>
                                                        </div>
                                                    </Segment>
                                                }
                                                <div style={{height:'30px'}}></div>
                                                {!this.state.mergeAddressSelected ? <div className="right-aligned">
                                                    <Button color="teal" type="button" content="Start Merge" onClick={() => {
                                                        this.setState({mergeAddressSelected: true})
                                                    }}/></div>:<div className="right-aligned">
                                                    <Button content="Cancel" type="button" onClick={()=>{this.setState({mergeAddressSelected:false,selectedMergeAddressId:undefined})}}/>
                                                    <Button content="Confirm Change" primary loading={this.state.merging}/></div>}
                                            </Form>
                                        </Segment>
                                    </div>
                                    }
                                    wide="very"
                                    flowing
                                    on='click'
                                    open={this.state.openPopup}
                                    position="left center"
                                    hideOnScroll={true}
                                    onClose={()=>{this.setState({openPopup:false})}}
                                />
                            </Grid.Column>}
                        </Grid.Row>
                        {this.state.message && <Grid.Row>
                            <Grid.Column>
                                <Message positive={this.state.message.success} negative={!this.state.message.success} header={this.state.message.message} onDismiss={()=>{this.setState({message:undefined})}}/>
                            </Grid.Column>
                        </Grid.Row>}
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Segment style={{height:'100%'}}>
                                    <Label color='blue' ribbon>
                                        Property Specification
                                    </Label>
                                    <p></p>
                                    <p></p>
                                    <Grid.Column width={8}>
                                        <dl>
                                            <dt>No Of bedrooms</dt>
                                            <dd>: {property['no_of_bedrooms']?property['no_of_bedrooms']:"NA"}</dd>

                                            <dt>No of bathrooms</dt>
                                            <dd>: {property['no_of_bathrooms']?property['no_of_bathrooms']:"NA"}</dd>

                                            <dt>Furnishing Type</dt>
                                            <dd className="format-capitalize">:{property['furnishing_type']?property['furnishing_type']:"NA"}</dd>

                                            <dt>Garage available</dt>
                                            <dd>: {property['garage'] === true ? 'Yes' : 'No'}</dd>
                                            <dt>Property Notes</dt>
                                            <dd>: {property['property_notes']?property['property_notes']:"NA" }</dd>
                                        </dl>
                                    </Grid.Column>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Segment style={{height:'100%'}}>
                                    <Label color='blue' ribbon>
                                        Meter and gauge Details
                                    </Label>
                                    <p></p>
                                    <Grid.Column width={8}>
                                        <dl>
                                            <dt>Gas Meter Serial</dt>
                                            <dd>: {property['gas_meter_sno']?property['gas_meter_sno']:"NA"}</dd>
                                            <dt>Gas Meter Location</dt>
                                            <dd>: {property['gas_meter_location']?property['gas_meter_location']:"NA"}</dd>
                                            <dt>Electric Meter Serial</dt>
                                            <dd>: {property['electric_meter_sno']?property['electric_meter_sno']:"NA"}</dd>
                                            <dt>Electric Meter Location</dt>
                                            <dd>: {property['electric_meter_location']?property['electric_meter_location']:"NA"}</dd>
                                            <dt>Water Meter Serial</dt>
                                            <dd>: {property['water_meter_sno']?property['water_meter_sno']:"NA"}</dd>
                                            <dt>Water Meter Location</dt>
                                            <dd>: {property['water_meter_location']?property['water_meter_location']:"NA"}</dd>
                                        </dl>
                                    </Grid.Column>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid></Tab.Pane>,
            }
        ];

        this.props.userRole === "admin" ? panes.push(
            {
                menuItem: (
                    <Menu.Item key='propertyHistory' content="Property's Inspection History">
                    </Menu.Item>
                ),
                render: () => <Tab.Pane>
                    <div>
                        <Header as='h2' content="Inspection History" textAlign="center"/>
                        <InspectionHistory propertyId={property.id}/>
                    </div>
                </Tab.Pane>,
            }

        ) : null
        return (
            <div>
                <Header content="Property Details" size="large" textAlign="center"/>
                <Tab panes={panes.reverse()}/>
            </div>);
    }

}

export default ViewPropertyDetails;


// WEBPACK FOOTER //
// ./src/views/properties/view_property_details.js